import { IFilterSliderConstant } from './filterSliderConstant';

export type DirectDealSliderFilterKeyType = 'engineOutputInPs' | 'price' | 'manufacturedYear' | 'operationTime';

// 연식은 올해를 포함해 최근 14개 연도만 고를 수 있고, 해가 바뀌면 범위가 함께 한 해씩 이동한다.
const MANUFACTURED_YEAR_TICK_COUNT = 14;
const currentYear = new Date().getFullYear();

// 슬라이더에서 고를 수 있는 실제 값(눈금)
export const directDealSliderTicks: Record<DirectDealSliderFilterKeyType, number[]> = {
  engineOutputInPs: [50, 100, 130, 150, 175, 200, 300],
  price: [
    10000000, 20000000, 30000000, 40000000, 50000000, 60000000, 70000000, 80000000, 90000000, 100000000, 200000000,
  ],
  manufacturedYear: Array.from(
    { length: MANUFACTURED_YEAR_TICK_COUNT },
    (_, index) => currentYear - (MANUFACTURED_YEAR_TICK_COUNT - 1) + index,
  ),
  // 0시간 이상은 제한 없음과 같아 눈금에서 뺀다.
  operationTime: [500, 1000, 1500, 2000, 2500, 3000],
};

// 슬라이더 위치는 눈금의 순번으로 다루며, 양 끝 칸(0, 눈금 수 + 1)은 '제한 없음'이다.
// 끝 숫자와 '제한 없음'을 구분해야 '50마력 이하', '3,000시간 이상' 같은 조건을 표현할 수 있다.
const createSliderConstant = (key: DirectDealSliderFilterKeyType, prefix: string): IFilterSliderConstant => {
  const max = directDealSliderTicks[key].length + 1;

  return {
    marks: Array.from({ length: max + 1 }, (_, index) => ({ value: index, label: '' })),
    min: 0,
    max,
    minDistance: 1,
    prefix,
  };
};

export const directDealFilterSliderConstant: Record<DirectDealSliderFilterKeyType, IFilterSliderConstant> = {
  engineOutputInPs: createSliderConstant('engineOutputInPs', '마력'),
  price: createSliderConstant('price', '원'),
  manufacturedYear: createSliderConstant('manufacturedYear', '년식'),
  operationTime: createSliderConstant('operationTime', '시간'),
};

export const isDirectDealSliderFilterKey = (key: string): key is DirectDealSliderFilterKeyType => {
  return key in directDealFilterSliderConstant;
};

export interface IDirectDealSliderQuickSetting {
  label: string;
  // 실제 값 기준의 범위. 값이 없는 쪽은 '제한 없음'이다.
  min?: number;
  max?: number;
}

// 슬라이더 범위를 한 번에 바꾸는 퀵 세팅 버튼. 연식은 슬라이더 범위와 함께 해마다 이동한다.
// '전체'는 양쪽 모두 제한 없음이라 범위를 비워 둔다.
const ALL_QUICK_SETTING: IDirectDealSliderQuickSetting = { label: '전체' };

export const directDealSliderQuickSettings: Record<DirectDealSliderFilterKeyType, IDirectDealSliderQuickSetting[]> = {
  engineOutputInPs: [
    ALL_QUICK_SETTING,
    { label: '50마력 이하', max: 50 },
    { label: '50~100마력', min: 50, max: 100 },
    { label: '100~130마력', min: 100, max: 130 },
    { label: '130마력 이상', min: 130 },
  ],
  price: [
    ALL_QUICK_SETTING,
    { label: '3천만원 이하', max: 30000000 },
    { label: '3~5천만원', min: 30000000, max: 50000000 },
    { label: '5천만~1억', min: 50000000, max: 100000000 },
    { label: '1억 이상', min: 100000000 },
  ],
  manufacturedYear: [
    ALL_QUICK_SETTING,
    { label: `${currentYear - 3}년 이후`, min: currentYear - 3 },
    { label: `${currentYear - 10}~${currentYear - 4}`, min: currentYear - 10, max: currentYear - 4 },
    { label: `${currentYear - 12}~${currentYear - 8}`, min: currentYear - 12, max: currentYear - 8 },
    { label: `${currentYear - 13}년 이전`, max: currentYear - 13 },
  ],
  operationTime: [
    ALL_QUICK_SETTING,
    { label: '500시간 이하', max: 500 },
    { label: '500~1,000시간', min: 500, max: 1000 },
    { label: '1,000~2,000시간', min: 1000, max: 2000 },
    { label: '2,000시간 이상', min: 2000 },
  ],
};
